export default "__VITE_PUBLIC_ASSET__e6307e3b__"